// extracted by mini-css-extract-plugin
export default {"heading":"AlertsPage_heading__n6Doz","tabs":"AlertsPage_tabs__9lKov","root":"AlertsPage_root__GkoK-"};